import { useCallback, type RefObject } from 'react';
import { getSearchFocusableElements } from '../search-focusable-utils';

export function useSuggestionsSurfaceFocus({
    variant,
    desktopSuggestionsPanelRef,
    mobileSuggestionsPanelRef,
}: {
    variant: 'desktop' | 'mobile';
    desktopSuggestionsPanelRef: RefObject<HTMLDivElement | null>;
    mobileSuggestionsPanelRef: RefObject<HTMLDivElement | null>;
}): {
    focusFirstInSuggestionsSurface: () => void;
} {
    const getSuggestionsSurfaceFocusables = useCallback((): HTMLElement[] => {
        const root = variant === 'mobile' ? mobileSuggestionsPanelRef.current : desktopSuggestionsPanelRef.current;
        if (!root) return [];
        return getSearchFocusableElements(root);
    }, [variant, desktopSuggestionsPanelRef, mobileSuggestionsPanelRef]);

    const focusFirstInSuggestionsSurface = useCallback(() => {
        getSuggestionsSurfaceFocusables()[0]?.focus();
    }, [getSuggestionsSurfaceFocusables]);

    return { focusFirstInSuggestionsSurface };
}
